import { getToken } from './auth';
import axiosInstance from '../helpers/axios';

// Get areas
export const getAreas = async () => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/catalog/area/`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get area's info
export const getAreaInfo = async (idArea) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/catalog/area/${idArea}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register area
export const registerArea = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/catalog/area/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update area
export const updateArea = async (idArea, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/catalog/area/${idArea}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update area
export const deleteArea = async (idArea) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/catalog/area/${idArea}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};
